// Generated by ReScript, PLEASE EDIT WITH CARE

import * as JsxRuntime from "react/jsx-runtime";

function CardElementShimmer(props) {
  return JsxRuntime.jsx("div", {
    children: JsxRuntime.jsxs("div", {
      children: [
        JsxRuntime.jsx("div", {
          className: " w-10 h-5 rounded-full m-3 bg-white bg-opacity-70 "
        }),
        JsxRuntime.jsx("div", {
          className: " my-auto w-24 h-2 rounded m-3 bg-white bg-opacity-70 "
        })
      ],
      className: "flex flex-row  my-auto"
    }),
    className: "shine w-full h-12 rounded"
  });
}

let make = CardElementShimmer;

export {
  make,
}
/* react/jsx-runtime Not a pure module */
